<template>
  <div v-for="(notificationsByElementId, day) in notificationsByDayAndElementId">
    <div class="flex-center-center small text-medium-emphasis column-gap-2 nobr mb-2">
      <v-spacer style="border-top: 1px dashed #999"></v-spacer>{{ day }}<v-spacer style="border-top: 1px dashed #999"></v-spacer>
    </div>
    <div v-for="elementNotifications in notificationsByElementId" class="mb-2 mx-3">
      <div class="d-flex align-end" :class="elementNotifications.target.element ? 'mb-3' : 'mb-1'">
        <planning-element-view v-if="elementNotifications.target.element"
                               :el="elementNotifications.target.element" :show-details-items="elShowDetailsItems(elementNotifications.notifs)"
                               :title="elementNotifications.target.element.display_title" class="flex-grow-1"
                               style="cursor: default; position: relative; font-size: 75%" disable-mini-element disable-styling>
        </planning-element-view>
        <div v-else-if="elementNotifications.target.title" class="align-self-center">{{ elementNotifications.target.title }}</div>
        <v-btn-icon v-if="elementNotifications.target.url" :title="$t('HOME.OPEN_IN_PROJECT')" :to="elementNotifications.target.url" size="x-small" class="ml-1" @click="close">
          <v-icon>far fa-external-link</v-icon>
        </v-btn-icon>
      </div>
      <notification-list-line v-for="notif in elementNotifications.notifs" :key="notif.id" :notif="notif">
      </notification-list-line>
    </div>
  </div>
</template>

<script>
  import NotificationListLine from '@/components/Notifications/NotificationListLine.vue';
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';

  export default {
    components: {
      NotificationListLine,
      PlanningElementView,
    },
    props: {
      notifications: { type: Array, required: true },
      projectsMap: { type: Map, default: () => new Map() },
      elementsMap: { type: Map, default: () => new Map() },
    },
    emits: ['close'],
    computed: {
      notificationsByDayAndElementId() {
        const output = {};
        this.notifications.forEach((notif) => {
          let date = moment(notif.date_of_creation).calendar();
          const atIndex = date.indexOf(this.$t('NOTIFICATIONS.DATE_TIME_SEPARATOR'));
          if (atIndex != -1) date = date.substring(0, atIndex); // remove time part of the date
          if (! output[date]) output[date] = {};
          const elementId = this.getNotifElementId(notif);
          if (! output[date][elementId]) {
            output[date][elementId] = {
              target: {
                title: notif.target_title,
                url: this.notifTargetUrl(notif),
                element: notif.target_type == 'element' && this.elementsMap.get(elementId), // full PlanningElement if available
              },
              notifs: [],
            };
          }
          output[date][elementId].notifs.push(notif);
        });
        return output;
      },
    },
    methods: {
      getNotifElementId(notif) {
        return `p${notif.section_id}e${notif.target_id}`;
      },
      notifTargetUrl(notif) {
        if (notif.section_type == 'planning' && notif.section_id) {
          if (notif.target_type == 'element' && notif.target_id) return `${this.projectUrl(notif)}?el=${parseInt(notif.target_id, 10)}`;
          if (notif.target_type == 'exchangeCenter') return `${this.projectUrl(notif)}?open=exchanges`;
        }
        return null;
      },
      projectUrl(notif) {
        if (notif.section_type != 'planning' || ! notif.section_id) return null;
        const project = this.projectsMap.get(notif.section_id);
        if (! project) return null;
        const { title: projectTitle, access_right: projectAccessRight } = project;
        const isConsult = projectAccessRight == 'consult';
        return `/${isConsult ? 'viewer/' : 'planning/'}${project.id}/${window.slugify(projectTitle || "New project")}`;
      },
      elShowDetailsItems(notifs) { // get the list of element fields to display (changed fields)
        const notifField2ElField = { html: 'description', date: 'dates', progress: 'progress', checklist: 'checklist', user: 'users', link: 'links', budget: 'budgets' };

        const fields = new Set();
        notifs.forEach((notif) => {
          notif.fields?.forEach((field) => {
            if (notifField2ElField[field]) fields.add(notifField2ElField[field]);
          });
        });
        return fields.size ? [...fields] : null;
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
